if (!customElements.get('sticky-cart')) {
  customElements.define(
    'sticky-cart',
    class StickyCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.submitButton = this.querySelector('.sticky-cart__submit');
        this.onSubmit = this.onSubmit.bind(this);
        this.submitButton?.addEventListener('click', this.onSubmit);
      }

      connectedCallback() {
        this.pastProductInfo = false;
        this.footerVisible = false;

        const target = document.getElementById(this.dataset.observeTarget);
        if (target && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              this.pastProductInfo = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.updateVisibility();
            },
            { threshold: 0 }
          );
          this.observer.observe(target);
        }

        const footer = document.querySelector('.footer__signup-panel') || document.querySelector('.footer');
        if (footer && 'IntersectionObserver' in window) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              this.footerVisible = entries[0].isIntersecting;
              this.updateVisibility();
            },
            { threshold: 0 }
          );
          this.footerObserver.observe(footer);
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            this.updateVariant(event.data.variant, event.data.html);
          });
        }
      }

      updateVisibility() {
        this.classList.toggle('sticky-cart--visible', this.pastProductInfo && !this.footerVisible);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.footerObserver?.disconnect();
        if (typeof this.unsubscribeVariantChange === 'function') this.unsubscribeVariantChange();
      }

      updateVariant(variant, html) {
        ['StickyCartPrice', 'StickyCartVariant'].forEach((idBase) => {
          const source = html.getElementById(`${idBase}-${this.sectionId}`);
          const destination = this.querySelector(`#${idBase}-${this.sectionId}`);
          if (source && destination) destination.innerHTML = source.innerHTML;
        });

        const imageSource = html.getElementById(`StickyCartImage-${this.sectionId}`);
        const imageDestination = this.querySelector(`#StickyCartImage-${this.sectionId}`);
        if (imageSource && imageDestination) {
          imageDestination.src = imageSource.currentSrc || imageSource.src;
          if (imageSource.srcset) imageDestination.srcset = imageSource.srcset;
        }

        if (this.submitButton) {
          this.submitButton.toggleAttribute('disabled', !variant.available);
          const label = this.submitButton.querySelector('.liquid-btn__label');
          if (label) label.textContent = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
        }
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.submitButton.hasAttribute('disabled')) return;

        const form = document.getElementById(this.dataset.productFormId);
        if (!form) return;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      }
    }
  );
}
